<template>
    <select id="source_id" ref="input" v-model="source_id"
            class="form-control form-control-lg trading-name-tom-selector" name="source_id"
            placeholder=" Select one">
    </select>
</template>

<script>
import TomSelect from 'tom-select'
import {bookingEditSourceId} from '@/modules/common/api'
import {inquiryEditSourceId} from '@/modules/common/api'
export default {
    name: "SelectSource",
    props: {
        source_ids: "",
        event_inquiry_type_id: 0,
        value: 0,
        viewPage: null,
        bookingId: '',
        itemType: {
            type: String,
            default(){
                return "booking"
            }
        },
        inquiryId: {
            type: Number,
            default(){
                return 0
            }
        },

    },
    data() {
        return {
            names: this.source_ids,
            select: null,
            source_id: this.value
        }
    },
    mounted() {
        this.initiateDropdown(this.names)
    },
    methods: {
        initiateDropdown(names) {
            let vm = this;
            this.$nextTick(() => {
                // I added the variable to window to use it in jquery in other pages
                this.select = new TomSelect(this.$refs['input'], {
                    preload: true,
                    labelField: 'inquiry_name',
                    searchField: ['inquiry_name'],
                    valueField: 'inquiry_type_id',
                    highlight: false,
                    persist: false,
                    load: function (query, callback) {
                        let self = this;

                        if (self.loading > 1) {
                            callback();
                            return;
                        }
                        callback(vm.names)
                        self.settings.load = null;
                    }
                })
                this.select.on('load', (value, item) => {
                    let selected_inquiry_type_id = value[0].inquiry_type_id;
                    if (this.event_inquiry_type_id) {
                        selected_inquiry_type_id = this.event_inquiry_type_id
                    } else if (this.source_id) {
                        selected_inquiry_type_id = this.source_id
                    }
                    this.select.addItem(selected_inquiry_type_id);
                    this.source_id = selected_inquiry_type_id
                    if(document.getElementById("source_id-ts-control")){
                        document.getElementById("source_id-ts-control").setAttribute('readonly', true);
                    }
                })
                this.select.on('item_add', (value, item) => {
                    if(this.viewPage){
                        if(this.source_id != value) {
                        if(vm.itemType == 'inquiry'){

                                    inquiryEditSourceId(vm.inquiryId, value).then((response) => {
                                        $.notify(response.data.message, response.data.type);
                                    }).catch((error) => {
                                        // Handle any errors here
                                    });

                        }else{
                            bookingEditSourceId(this.bookingId, value).then((response) => {
                                $.notify(response.data.message, response.data.type);
                            }).catch((error) => {
                                // Handle any errors here
                            });
                        }
                        }

                    }
                })
            })
        },
    },
    watch: {
        source_id(value) {
            this.$emit('input', value)
        },
        deep: true,
        immediate: true
    }
}
</script>

